import { render } from "./EmailComposer.vue?vue&type=template&id=7cea7873&scoped=true"
import script from "./EmailComposer.vue?vue&type=script&lang=ts"
export * from "./EmailComposer.vue?vue&type=script&lang=ts"

import "./EmailComposer.vue?vue&type=style&index=0&id=7cea7873&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cea7873"

export default script